import {Injectable} from '@angular/core';
import {NavigationService} from '../../core/navigation.service';
import {Router} from "@angular/router";

@Injectable()
export class WebNavigationService extends NavigationService {

  expanded = true;
  expandConciliacion = false;
  expandPayments = false;
  expandTransfers = false;
  expandPromotions = false;
  expandBanneres = false;
  expandUsers = false;

  constructor(private router: Router) {
    super();
  }

  goToDashboar() {
  }

  selectOption(option) {

    if (option === 'conciliacion') {
      this.expandConciliacion = !this.expandConciliacion;
    } else if (option === 'pagos') {
      this.expandPayments = !this.expandPayments;
    } else if (option === 'transferencias') {
      this.expandTransfers = !this.expandTransfers;
    } else if (option === 'promociones') {
      this.expandPromotions = !this.expandPromotions;
    } else if (option === 'users') {
      this.expandUsers = !this.expandUsers;
    } else {
      super.selectOption(option);
    }
  }

  toggle() {
    this.expanded = !this.expanded;
  }

  doExpand() {
    this.expanded = true;
  }

  navigateToDashboard() {
    this.router.navigate(['ganalottodo']);
    console.log('WebNavigationService:navigateToDashboard');
  }

  navigateToPayments() {
    this.router.navigate(['ganalottodo/pagos']);
  }

  navigateToBusinessRules() {
    this.router.navigate(['ganalottodo/business-rules']);
  }

  navigateToBanners() {
    this.router.navigate(['']);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/navigation.service.ts